module.exports = __webpack_public_path__ + "img/nothing2.1e8f651d.png";